export const successContentSx = {
  display: 'flex',
  flexDirection: 'column',
  maxWidth: '350px',
  height: '70%',
  alignItems: 'center',
};

export const helperLinkTextSx = {
  margin: 0,
};
